export function mapCandidateResponse(candidate) {
  try {
    const c = candidate
    if (c === null || c.length === 0) return {}
    let professional = c.careerStage === 'Professional Experienced'

    return {
      id: c.candidateId[0]._id.$oid,
      firstName: c.candidateId[0].firstName,
      lastName: c.candidateId[0].lastName,
      email: c.userEmail,
      DOB: c.candidateDOB,
      nationality: c.candidateNationality,
      interCourseofStudies: professional ? c.profession : c.interCourseofStudies,
      universityName: professional ? c.company : c.universityName,
      interHigestGraduation: c.interHigestGraduation,
      cAddress: c.cAddress,
      cTelephone: c.cTelephone,
      preferdTypeOfHiring: c.preferdTypeOfHiring,
      careerStage: c.careerStage,
      documents: c.canDocs,
      profileSharing: c.profileSharing,
      cProfilePic: c.cProfilePic,
      candidateVideo: c.cProfileVideo,
      cProfileView: c.cProfileView,
      cProfileVideoView: c.cProfileVideoView,
      experiences: c.canPracExp,
      educations: c.canEdu,
      skills: c.canSkill,
      languages: c.canLang,
      // corporateInfo: c.corporateInfo && c.corporateInfo[0],
      reuseVideoInterview: c.reuseVideoInterview,
      corporateIdentityCandidate: c.corporateIdentityCandidate,
      numberOfInterviewDone: c.numberOfInterviewDone,
      closeUpEnrollType: c.closeUpEnrollType,
      closeUpConnected: c.closeUpConnected ? true : false,
    }
  } catch (error) {
    console.log(error)
  }
}
